import { render, staticRenderFns } from "./TheYearSlider.vue?vue&type=template&id=19247d3e&scoped=true&"
import script from "./TheYearSlider.vue?vue&type=script&lang=coffee&"
export * from "./TheYearSlider.vue?vue&type=script&lang=coffee&"
import style0 from "./TheYearSlider.vue?vue&type=style&index=0&id=19247d3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19247d3e",
  null
  
)

export default component.exports